module.exports = __webpack_public_path__ + "img/digital.d39d2160.jpg";